module.exports = __webpack_public_path__ + "img/frame.68187713.webp";